import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Outlet, useNavigate, useParams} from 'react-router'
import { AppContext } from '../../Context'
import { getRecord } from '../../services/record-services'

export const DeclarationContext = React.createContext({})

export default function DeclarationPage() {
  const { tokenId, employee } = useContext(AppContext)
  const [record, setRecord] = useState(null)

  const { id } = useParams()
  const navigate = useNavigate()

  const fetchRecord = useCallback(async () => {
    if(employee) {
      const result = await getRecord(id, recordData)
      if (result.data.getRecord && result.data.getRecord.length > 0) {
        const r = result.data.getRecord[0]
        setRecord(r)
      } else {
        navigate('/error/404')
      }
    }
  }, [id])

  useEffect(() => {
    if (id && tokenId) {
      fetchRecord()
    }
  }, [id, tokenId, fetchRecord])


  const myContext = {
    recordId: id,
    record,
    setRecord,
    parentHistory: navigate
  }
  return <DeclarationContext.Provider value={ myContext }>
      <Outlet />
    </DeclarationContext.Provider>
}

const recordData = `
  _id
  reference
  status
  partnerAnnualNetIncome
  singleParent
  babysittingMode
  hoursType
  startDate
  validateDate
  archivedDate
  child {
    id
    ageCategory
    expired
    dateOfBirth
    firstName
    lastName
  }
  employee {
    firstName
    lastName
  }
`

export const declarationData = `
  _id
  basageId
  recordId
  ratpId
  status
  declareDate
  period
  hours
  attachments {
    category
    key
    name
    size
    mimetype
  }
`
